import terraLogo from 'media/logos/terra_logo.png'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

export default function UserDirectoryUserInfoTableHeader() {
    return (
        <div className='grid w-full min-w-[720px] grid-cols-[repeat(33,minmax(0,1fr))] bg-gray-200 font-semibold divide-x divide-gray-400 text-xs border-b border-gray-400'>
            <div className='col-span-1 px-2 py-1 text-center truncate text-sm'>Id</div>
            <div className='col-span-3 px-2 py-1 truncate min-w-0 text-sm'>Auth0</div>
            <div className='col-span-1 px-2 py-1 text-center truncate flex items-center justify-center gap-1.5 text-sm'>
                <img
                    src={trainingPeaksAppIcon}
                    alt="TrainingPeaks"
                    className="h-4 w-4 flex-shrink-0 rounded-sm"
                />
            </div>
            <div className='col-span-1 px-2 py-1 text-center truncate flex items-center justify-center gap-1.5 text-sm'>
                <img
                    src={terraLogo}
                    alt="Terra Icon"
                    className="h-4 w-4 flex-shrink-0 rounded-sm"
                />
            </div>
            <div className='col-span-4 px-2 py-1 truncate text-sm'>Organization</div>
            <div className='col-span-3 px-2 py-1 truncate min-w-0 text-sm'>Group</div>
            <div className='col-span-3 px-2 py-1 truncate text-sm'>Type</div>
            <div className='col-span-2 px-2 py-1 truncate min-w-0 text-sm'>First Name</div>
            <div className='col-span-2 px-2 py-1 truncate min-w-0 text-sm'>Last Name</div>
            <div className='col-span-6 px-2 py-1 truncate min-w-0 text-sm'>Email</div>
            <div className='col-span-1 px-2 py-1 truncate min-w-0 text-sm text-center'>v5</div>
            <div className='col-span-4 px-2 py-1 truncate min-w-0 text-sm'>Created Date</div>
            <div className='col-span-2 px-2 py-1 text-center truncate min-w-0 text-sm'>Actions</div>
        </div>
    )
}